import './source_view.js.coffee'
Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.GoogleMyBusinessSourceView extends Settings.Views.Topics.SourceView
  id: 'new_google_my_business_source'
  type: Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessContent.TYPE
  icon: image_path('source_google_my_business.png')
  channelViewClass: Settings.Views.Topics.GoogleMyBusinessChannelView
